<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div class="d-block w-100">
        <ul class="list-unstyled" id="searchFields">
          <li>
            <div class="tab w-100">
              <a #monthlyInvoicesTab
                (click)="refreshInvoices(monthlyInvoicesTab.id)"
                [ngClass]="{'active':activeTab == monthlyInvoicesTab.id}"
                id="monthly-invoices-tab">
                Monthly Invoices
              </a>
              <a #invoicesTab
                (click)="refreshInvoices(invoicesTab.id)"
                [ngClass]="{'active':activeTab == invoicesTab.id}"
                id="invoices-tab">
                Prepaid Invoices
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="form-group">
        @if (!invoices || invoices.length < 1) {
          <div class="no-invoice-message">
            <p>No invoices available</p>
          </div>
        }
        @if (!!invoices && invoices.length > 0) {
          <table
            class="table table-hover table-responsive-md table-wrap-sm-1">
            <thead>
              <tr>
                <th id="invoices" scope="col">Invoice</th>
                <th id="date-created" scope="col">Date Created</th>
                <th class="text-center" scope="col">Download</th>
              </tr>
            </thead>
            <tbody class="table-hover text-nowrap">
              @for (invoice of invoices; track invoice) {
                <tr class="cursor-pointer  active-color">
                  <td (click)="view(invoice)">
                    <span class="p-column-title">Invoice</span>
                    {{ invoice.invoiceName }}
                    @if (invoice.refundFeesPending) {
                      <span class="badge badge-warning refund-fees-pending"
                        pTooltip="Refund fees for this period are still being finalised">
                        Refund fees pending
                      </span>
                    }
                  </td>
                  <td (click)="view(invoice)">
                    <span class="p-column-title">Date Created</span>
                    {{ invoice.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                  </td>
                  <hr/>
                  <td>
                    <div class="text-center">
                      <div class="disabled-tooltip-wrapper"
                        [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot download invoices.' : null">
                        <div (click)="downloadInvoice(invoice)"
                          [class.grey-circle-style]="isGuestAdminUser()"
                          class="circle-style">
                          <i class="fa fa-download fa-lg"></i>
                        </div>
                      </div>
                      <span class="p-column-title ">Download</span>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </div>
</div>
<ngx-ui-loader></ngx-ui-loader>